import {
    type UserData,
    NEXT_LOCALES,
    NextLocale,
} from '@beat-venues/common-types';
import { CommonProps, Dropdown, InputField } from '@beat-venues/ui/react';
import { cva, VariantProps } from 'class-variance-authority';
import { Dispatch, FormEvent, ReactElement, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

const NewUserFormStyles = cva('');
interface NewUserFormProps
    extends CommonProps,
        VariantProps<typeof NewUserFormStyles> {
    newUser: Pick<UserData, 'email' | 'firstName' | 'lastName' | 'language'>;
    setNewUser: Dispatch<
        SetStateAction<
            Pick<UserData, 'email' | 'firstName' | 'lastName' | 'language'>
        >
    >;
    handleSubmit?: (e: FormEvent) => void;
    emailParam?: string | null;
    userLanguage?: NextLocale;
}

export const NewUserForm = ({
    newUser,
    setNewUser,
    emailParam,
    userLanguage,
    className,
}: NewUserFormProps): ReactElement => {
    const { t, i18n } = useTranslation('');
    return (
        <div>
            <div className={twMerge(NewUserFormStyles({ className }))}>
                <InputField
                    required
                    className="mb-2"
                    label={t(`userAccount.email`) || ''}
                    name="email"
                    type="email"
                    value={emailParam ?? newUser?.email}
                    onInput={(email) =>
                        setNewUser({
                            ...newUser,
                            email,
                        })
                    }
                />
                <InputField
                    className="mb-2"
                    label={t(`userAccount.firstName`) || ''}
                    name="firstName"
                    type="text"
                    value={newUser?.firstName}
                    onChange={(firstName) =>
                        setNewUser({
                            ...newUser,
                            firstName,
                        })
                    }
                />
                <InputField
                    className="mb-2"
                    label={t(`userAccount.lastName`) || ''}
                    name="lastName"
                    type="text"
                    value={newUser?.lastName}
                    onChange={(lastName) =>
                        setNewUser({
                            ...newUser,
                            lastName,
                        })
                    }
                />
                <Dropdown
                    className="mb-6 bg-gray-700"
                    layout="mybeat"
                    defaultValue={
                        newUser.language
                            ? newUser.language
                            : userLanguage &&
                              NEXT_LOCALES.includes(userLanguage)
                            ? userLanguage
                            : i18n.language
                    }
                    emptyTitle={t('userAccount.emptyDropdownTitle') ?? ''}
                    id="language"
                    label={t(`userAccount.language`) || ''}
                    options={NEXT_LOCALES.map((locale) => ({
                        key: locale,
                        value: t(`language.${locale}`),
                    }))}
                    onChange={(newValue) =>
                        setNewUser({
                            ...newUser,
                            language: newValue as NextLocale,
                        })
                    }
                />
            </div>
        </div>
    );
};
